
import React, { useState, useEffect } from "react";
import { Form, Button, Table } from "antd";
import { FormItemTypeEnum } from "../../../../components2/YhFormBox/Types"
import { YhFormItemsBox } from "../../../../components2/YhFormBox"
import { useWarehouseModel } from "../warehouseModel"
import useMdmModel from "../../../../model/mdmModel"
import { useNavModel } from "../../../../model/navModel";
import { DetailType } from "../../../../types/FmsEnums";
import { IWarehouseParams, IWarehouseSearch, IWarehouseDetail, IWarehouseInsert, IWarehouseUpdata, IWarehouseDisable } from "../warehouseTypes"

import { setTitle,loadDictParam } from "../../../../utils/utils"
const WarehouseDetail = () => {
    const [form] = Form.useForm();
    const { mdmBranch, mdmOrgan,dict } = useMdmModel();
    const { selectedNavId, addNav, closeNav, getSelectedNavState, findNav, replaceNav } = useNavModel()
    const { addParam, selectedRow, warehouseType, setWarehouseType, setAddParam, updataAddParam, setSelectedRow, setSelectedRowKeys, updataEditParam, insertDetail, updataDetail } = useWarehouseModel()
    const [modes, setModes] = useState<any>(getSelectedNavState("state"))
    const { id, pageParams } = modes
    const { mode, id: ids } = pageParams
    useEffect(() => {
        if (mode == DetailType.add) {
            form.setFieldsValue(addParam)
        } else if (mode == DetailType.edit || mode == DetailType.look) {
            form.setFieldsValue(selectedRow[0])
        }
    }, [addParam, selectedRow[0]])
    const onFinish = (values: IWarehouseInsert | IWarehouseUpdata) => {
        if (mode == DetailType.add) {
            insertDetail(values).then(res => {
                if (res) close()
            })
        } else if (mode == DetailType.edit) {
            updataDetail(values as IWarehouseDetail).then(res => {
                if (res) close()
            })
        }
    }
    useEffect(()=>{
        setWarehouseType(loadDictParam('warehouse-type',dict))
    },[])
    // useEffect(() => {
    //     return () => {
    //         const findInsert = findNav("2-1-1")
    //         const findEdit = findNav("2-1-2")
    //         !!!findInsert && setAddParam({});
    //         !!!findEdit && setSelectedRowKeys([]) && setSelectedRow([]);
    //     }
    // }, [selectedNavId])
    const close = () => {
        replaceNav(selectedNavId, "2-1")
    }
    const items = [
        {
            type: FormItemTypeEnum.Select,
            span: 8,
            fieldLabel: "分支编码",
            labelCol: { span: 6 },
            fieldName: "branch",
            options: mdmBranch
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "版本号",
            labelCol: { span: 6 },
            fieldName: "ver",
            disable: true,
        },
        {
            type: FormItemTypeEnum.TreeSelect,
            span: 8,
            fieldLabel: "所属机构",
            labelCol: { span: 6 },
            fieldName: "orgCode",
            treeData: mdmOrgan
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "仓库编码",
            labelCol: { span: 6 },
            fieldName: "code",
            disable: mode == DetailType.edit
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "仓库名称",
            labelCol: { span: 6 },
            fieldName: "name",
            rules: [{ required: true, message: '该项为必填项' }]
        },
        {
            type: FormItemTypeEnum.Select,
            span: 8,
            fieldLabel: "仓库类型",
            labelCol: { span: 6 },
            fieldName: "typeCode",
            // options: [{ key: "个人", value: "个人", label: "个人" }, { key: "集体", value: "集体", label: "集体" }]
            options:warehouseType
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "联系人",
            labelCol: { span: 6 },
            fieldName: "contact",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "联系电话",
            labelCol: { span: 6 },
            fieldName: "phone",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "联系地址",
            labelCol: { span: 6 },
            fieldName: "address",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 16,
            fieldLabel: "备注",
            labelCol: { span: 3 },
            fieldName: "note",
        },
        {
            type: FormItemTypeEnum.Switch,
            span: 8,
            fieldLabel: "状态",
            labelCol: { span: 6 },
            fieldName: "enable",
            valuePropName: "checked",
            checkedChildren: "启用",
            unCheckedChildren: "禁用"
        }
    ]
    const title = <div className="font-bold font-size-lg">{setTitle(mode)}仓库管理</div>
    const reset = () => {
        form.resetFields()
        if (mode == DetailType.add) {
            setAddParam({})
        } else if (mode == DetailType.edit) {
            form.setFieldsValue({ code: selectedRow[0].code })
            setSelectedRow([{ code: selectedRow[0].code }])
        }
    }
    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            hidden={mode == DetailType.look}
            onClick={() => form.submit()}
        >保存</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            hidden={mode == DetailType.look}
            onClick={() => reset()}
        >重置</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => close()}
        >取消</Button>
    </>
    return <Form
        form={form}
        onValuesChange={mode == DetailType.add ? updataAddParam : updataEditParam}
        onFinish={onFinish}
    >
        <YhFormItemsBox disabled={mode == DetailType.look} items={items} title={title} action={action} IclassName="p-20" />
    </Form>
}
export default WarehouseDetail